import { FelaCSS, spacing } from '@bridebook/ui';
import { IThemeProperties } from '@bridebook/web/lib/wedding-website/utils/get-theme-properties';

interface IStyles {
  stepContentWrapper: FelaCSS;
  title: FelaCSS;
  titleLarge: FelaCSS;
  subtitle: (isVisible: boolean) => FelaCSS;
  hint: FelaCSS;
  formWrapper: FelaCSS;
  fieldWrapper: FelaCSS;
  submitButton: (isValid: boolean) => FelaCSS;
}

const componentStyles: (themeProperties: IThemeProperties, isPreview?: boolean) => IStyles = (
  themeProperties,
  isPreview = false,
) => ({
  stepContentWrapper: {
    paddingVertical: spacing[8],
    paddingHorizontal: spacing[4],
    ...(!isPreview && {
      minWidthMobileLg: {
        paddingHorizontal: spacing[16],
      },
    }),
  },
  title: {
    fontFamily: themeProperties.primaryFontStyle.fontFamily,
    fontWeight: themeProperties.primaryFontStyle.fontWeight,
    fontSize: 16,
    lineHeight: 2,
    textAlign: 'center',

    minWidthMobileLg: {
      fontSize: 32,
    },
  },
  titleLarge: {
    fontSize: 24,
    lineHeight: 1.4,
    minWidthMobileLg: {
      fontSize: 48,
    },
  },
  subtitle: (isVisible) => ({
    fontFamily: themeProperties.primaryFontStyle.fontFamily,
    fontWeight: themeProperties.primaryFontStyle.fontWeight,
    fontSize: 16,
    textAlign: 'center',
    paddingVertical: spacing[6],
    visibility: isVisible ? 'visible' : 'hidden',
    minWidthMobileLg: {
      fontSize: 32,
    },
  }),
  hint: {
    fontFamily: themeProperties.secondaryFontStyle.fontFamily,
    fontWeight: themeProperties.secondaryFontStyle.fontWeight,
    fontSize: 14,
    paddingBottom: 4,
    textAlign: 'center',
  },
  formWrapper: {
    paddingTop: spacing[6],
    width: '100%',
    alignSelf: 'center',
    paddingHorizontal: spacing[4],
    minWidthMobileLg: {
      maxWidth: '360px',
      paddingHorizontal: 0,
    },
  },
  fieldWrapper: {
    gap: spacing[4],
    alignSelf: 'center',
    width: '100%',
    minWidthMobileLg: {
      maxWidth: '360px',
    },
  },
  submitButton: (isValid: boolean) => ({
    maxWidth: 320,
    ...(isValid && {
      backgroundColor: themeProperties.paletteColors.button,
      color: themeProperties.paletteColors.buttonText,
    }),
  }),
});

export default componentStyles;
